// Not ported (dead in the Angular app): deleteGroup
import { api } from '@/core/http/apiClient';
import { exportFile } from '@/core/http/helpers';
import type {
  CreateGroupPayload,
  GroupExportPayload,
  GroupJournalRow,
  GroupJournalView,
  GroupStructureView,
  GroupSummaryRow,
  GroupTrialBalanceView,
  PostGroupJournalPayload,
  ReverseGroupJournalPayload,
  ReviseGroupPayload,
  SaveGroupEventPayload,
  SaveGroupJournalPayload,
  SaveUndertakingPayload,
  UnfinaliseGroupPayload,
} from '@/core/models/group.models';

const base = 'Groups/';

export const groupService = {
  // ---- Group structure ----

  getGroups: (clientId?: string | null) =>
    api.get<GroupSummaryRow[]>(clientId ? `${base}getGroups/${clientId}` : `${base}getGroups`),

  getGroup: (groupPeriodId: string) => api.get<GroupStructureView>(`${base}getGroup/${groupPeriodId}`),

  createGroup: (payload: CreateGroupPayload) => api.post<GroupStructureView>(`${base}createGroup`, payload),

  saveUndertaking: (payload: SaveUndertakingPayload) => api.post<GroupStructureView>(`${base}saveUndertaking`, payload),

  deleteUndertaking: (groupPeriodId: string, groupUndertakingId: string) =>
    api.post<GroupStructureView>(`${base}deleteUndertaking/${groupPeriodId}/${groupUndertakingId}`, {}),

  // ---- Acquisitions and disposals ----

  saveEvent: (payload: SaveGroupEventPayload) => api.post<GroupStructureView>(`${base}saveEvent`, payload),

  deleteEvent: (groupPeriodId: string, groupEventId: string) =>
    api.post<GroupStructureView>(`${base}deleteEvent/${groupPeriodId}/${groupEventId}`, {}),

  // ---- Group trial balance ----

  getTrialBalance: (groupPeriodId: string) => api.get<GroupTrialBalanceView>(`${base}getTrialBalance/${groupPeriodId}`),

  rebuildTrialBalance: (groupPeriodId: string) =>
    api.post<GroupTrialBalanceView>(`${base}rebuildTrialBalance/${groupPeriodId}`, {}),

  exportTrialBalance: (payload: GroupExportPayload) =>
    exportFile(`${base}exportTrialBalance`, payload, Boolean(payload.isPrint)),

  // ---- Group and elimination journals ----

  getJournals: (groupPeriodId: string) => api.get<GroupJournalRow[]>(`${base}getJournals/${groupPeriodId}`),

  getJournal: (groupJournalId: string) => api.get<GroupJournalView>(`${base}getJournal/${groupJournalId}`),

  saveJournal: (payload: SaveGroupJournalPayload) => api.post<GroupJournalView>(`${base}saveJournal`, payload),

  postJournal: (payload: PostGroupJournalPayload) => api.post<GroupJournalView>(`${base}postJournal`, payload),

  reverseJournal: (payload: ReverseGroupJournalPayload) => api.post<GroupJournalView>(`${base}reverseJournal`, payload),

  deleteJournal: (groupJournalId: string) => api.post<boolean>(`${base}deleteJournal/${groupJournalId}`, {}),

  // ---- Readiness, finalisation and revision ----

  setReady: (groupPeriodId: string) => api.post<GroupStructureView>(`${base}setReady/${groupPeriodId}`, {}),

  finalise: (groupPeriodId: string) => api.post<GroupStructureView>(`${base}finalise/${groupPeriodId}`, {}),

  unfinalise: (payload: UnfinaliseGroupPayload) => api.post<GroupStructureView>(`${base}unfinalise`, payload),

  createRevision: (payload: ReviseGroupPayload) => api.post<GroupStructureView>(`${base}createRevision`, payload),
};
